import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '@helpers/util.service';

@Component({
  selector: 'app-main-image',
  templateUrl: './main-image.component.html',
  styleUrls: ['./main-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainImageComponent implements OnInit {
  @Output() public errorImg: EventEmitter<void> = new EventEmitter<void>();
  @Input() public imageId: string = null;
  @Input() public borderRadius = 0;
  @Input() public img: string;
  @Input() public imageWidth = 'inherit';
  @Input() public imageHeight = 'inherit';
  public imageStyles: { 'border-radius': string; width: string; height: string } = null;

  constructor(private utilService: UtilService) {}

  public getFileURI(): string {
    return this.utilService.getFilePath() + this.imageId;
  }

  ngOnInit() {
    this.imageStyles = {
      'border-radius': this.borderRadius ? this.borderRadius + 'px' : '25px',
      width: this.imageWidth,
      height: this.imageHeight,
    };
  }
}
